/* eslint-disable */
import axios from 'axios';
import dotenv from 'dotenv';
import jwt from 'jsonwebtoken';
import storage from './storage';
import { KEY_LOCAL_STORAGE } from './../const';
import CryptoJS from 'crypto-js';

dotenv.config();

let apiIP = '';
if (process.env.VUE_APP_IP_API) {
  apiIP = `${process.env.VUE_APP_IP_API}${
    process.env.VUE_APP_PORT_REST ? ':' + process.env.VUE_APP_PORT_REST : ''
  }`;
} else {
  apiIP = 'https://app.boxdasorte.com';
}

const idEmpresa = process.env.VUE_APP_WL || null;
const SECRET_KEY = process.env.VUE_APP_P || '';

// Função para criptografar dados
function encryptData(data) {
  try {
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      SECRET_KEY,
    ).toString();
    return encrypted;
  } catch (error) {
    console.error('Erro ao criptografar os dados:', error);
    throw error;
  }
}

export default {
  async getIP() {
    try {
      const response = await axios.get('https://api.ipify.org?format=json');
      return response.data.ip;
    } catch (error) {
      console.error(error);
      return 'Não foi possível localizar o IP';
    }
  },

  getDecoded() {
    const token = storage.lerStorage(KEY_LOCAL_STORAGE.USER_TOKEN);
    return token ? jwt.decode(token) : null;
  },

  getEnvIconeCarregando() {
    return process.env.VUE_APP_ICONE_CARREGANDO;
  },

  async getJson(jsonName) {
    try {
      const endpoint = `${apiIP}/g/buscaJson/${process.env.VUE_APP_SITE}/${jsonName}`;
      const response = await axios.get(endpoint);
      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async getAll(controllerName, extraParams, action = 'list') {
    try {
      let endpoint = `${apiIP}/${controllerName}/${action}`;
      if (extraParams && extraParams.PageNumber !== undefined) {
        endpoint += `/${extraParams.PageNumber}`;
      }

      endpoint = endpoint
        .replace('idEmpresa=null', `idEmpresa=${idEmpresa}`)
        .replace('idEmpresa=undefined', `idEmpresa=${idEmpresa}`);

      const token = storage.lerStorage(KEY_LOCAL_STORAGE.USER_TOKEN);
      const response = await axios.get(endpoint, {
        headers: { Authorization: token },
      });

      return response;
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data && error.response.data.error) {
        throw error.response.data.error;
      } else {
        throw 'Ação não Encontrada';
      }
    }
  },

  async getOne(controllerName, extraParams) {
    try {
      const endpoint = `${apiIP}/${controllerName}/${extraParams.PrimaryKey}/${extraParams.PageNumber}`;
      const response = await axios.get(endpoint, { params: extraParams });
      return response;
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data && error.response.data.error) {
        throw error.response.data.error;
      } else {
        throw 'Ação não Encontrada';
      }
    }
  },

  async getFilter(controllerName, extraParams) {
    try {
      const endpoint = `${apiIP}/${controllerName}/filter/${extraParams.SearchText}?page=${extraParams.PageNumber}`;
      const response = await axios.get(endpoint, { params: extraParams });
      return response;
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data && error.response.data.error) {
        throw error.response.data.error;
      } else {
        throw 'Ação não Encontrada';
      }
    }
  },

  async post(controllerName, action = 'create', data, extraParams) {
    try {
      let endpoint = `${apiIP}/${controllerName}/${action}`;
      if (extraParams && extraParams.PageNumber !== undefined) {
        endpoint += `/${extraParams.PageNumber}`;
      }

      data.idEmpresa = idEmpresa;

      // Criptografa os dados antes de enviar
      const encryptedData = encryptData(data);

      const token = storage.lerStorage(KEY_LOCAL_STORAGE.USER_TOKEN);
      const response = await axios.post(
        endpoint,
        { encryptedData },
        { headers: { Authorization: token } },
      );

      return response;
    } catch (error) {
      console.error(error);
      if (error.response && error.response.status === 401) {
        throw 'Sua sessão expirou, efetue login novamente para completar a ação';
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.error
      ) {
        throw error.response.data.error.errorMessage || 'Erro Sistemico';
      } else {
        throw 'Erro Sistemico';
      }
    }
  },

  async login(controllerName, action = 'login', data) {
    try {
      const endpoint = `${apiIP}/${controllerName}/${action}`;
      data.idEmpresa = idEmpresa;

      const basicAuth = 'Basic ' + btoa(JSON.stringify(data));
      const response = await axios.post(
        endpoint,
        {},
        { headers: { Authorization: basicAuth } },
      );

      return response;
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data && error.response.data.error) {
        throw error.response.data.error;
      } else {
        throw 'Erro no login';
      }
    }
  },

  async upload(controllerName, action, data, extraParams) {
    try {
      const endpoint = `${apiIP}/${controllerName}/${idEmpresa}/${action}`;

      // Criptografa os dados antes de enviar
      const encryptedData = encryptData(data);

      const response = await axios.post(
        endpoint,
        { encryptedData },
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );

      return response;
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data && error.response.data.error) {
        throw error.response.data.error;
      } else {
        throw 'Ação não Encontrada';
      }
    }
  },

  async put(controllerName, action = 'update', data, extraParams) {
    try {
      const endpoint = `${apiIP}/${controllerName}/${action}`;
      data.idEmpresa = idEmpresa;

      // Criptografa os dados antes de enviar
      const encryptedData = encryptData(data);

      const token = storage.lerStorage(KEY_LOCAL_STORAGE.USER_TOKEN);
      const response = await axios.put(
        endpoint,
        { encryptedData },
        { headers: { Authorization: token } },
      );

      return response;
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data && error.response.data.error) {
        throw error.response.data.error;
      } else {
        throw 'Ação não Encontrada';
      }
    }
  },

  async delete(controllerName, action = 'update', data, extraParams) {
    try {
      const endpoint = `${apiIP}/${controllerName}/${action}`;
      const token = storage.lerStorage(KEY_LOCAL_STORAGE.USER_TOKEN);

      // Criptografa os dados antes de enviar
      const encryptedData = encryptData(data);

      const response = await axios.delete(endpoint, {
        headers: { Authorization: token },
        data: { encryptedData },
      });

      return response;
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data && error.response.data.error) {
        throw error.response.data.error;
      } else {
        throw 'Ação não Encontrada';
      }
    }
  },

  async validaToken(token, controllerName, action) {
    try {
      const endpoint = `${apiIP}/${controllerName}/${action}`;
      const response = await axios.post(
        endpoint,
        { front: true, idEmpresa },
        { headers: { Authorization: token } },
      );

      return response;
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data) {
        return { data: { result: false } };
      } else {
        return { data: { result: false } };
      }
    }
  },
};
